var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "location_on"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_889_6622",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#1C1B1F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_889_6622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "location_on_2",
    d: "M9.99967 10.0001C10.458 10.0001 10.8504 9.83689 11.1768 9.5105C11.5031 9.18411 11.6663 8.79175 11.6663 8.33341C11.6663 7.87508 11.5031 7.48272 11.1768 7.15633C10.8504 6.82994 10.458 6.66675 9.99967 6.66675C9.54134 6.66675 9.14898 6.82994 8.82259 7.15633C8.4962 7.48272 8.33301 7.87508 8.33301 8.33341C8.33301 8.79175 8.4962 9.18411 8.82259 9.5105C9.14898 9.83689 9.54134 10.0001 9.99967 10.0001ZM9.99967 16.1251C11.6941 14.5695 12.9511 13.1563 13.7705 11.8855C14.59 10.6147 14.9997 9.48619 14.9997 8.50008C14.9997 6.98619 14.517 5.74661 13.5518 4.78133C12.5865 3.81605 11.4025 3.33341 9.99967 3.33341C8.5969 3.33341 7.41287 3.81605 6.44759 4.78133C5.48231 5.74661 4.99967 6.98619 4.99967 8.50008C4.99967 9.48619 5.4094 10.6147 6.22884 11.8855C7.04829 13.1563 8.30523 14.5695 9.99967 16.1251ZM9.99967 18.3334C7.76356 16.4306 6.09342 14.6633 4.98926 13.0313C3.88509 11.3994 3.33301 9.88897 3.33301 8.50008C3.33301 6.41675 4.00315 4.75703 5.34342 3.52091C6.6837 2.2848 8.23579 1.66675 9.99967 1.66675C11.7636 1.66675 13.3156 2.2848 14.6559 3.52091C15.9962 4.75703 16.6663 6.41675 16.6663 8.50008C16.6663 9.88897 16.1143 11.3994 15.0101 13.0313C13.9059 14.6633 12.2358 16.4306 9.99967 18.3334Z",
    fill: "#1C1B1F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOn);
export default __webpack_public_path__ + "static/media/location_on.a278325ec288c226b89e0d2911fceb71.svg";
export { ForwardRef as ReactComponent };